import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    hasTyreInfo: {
        hasInfo: 0,
    },
    tyreInfo: {
        tyrePosInfo: [],
    },
    selectedWheels: {
        selectedId: 0,
    },
    jobCardVehicleId: {
        vehicleId: null,
    },
    selectedWheelsForActions: {
        selectedWheelsData: [],
    },
    selectedCheckBoxState: {
        checkboxesState: []
    },
    selectedActivityRowData: {
        activityRowData: []
    },
    selectedVehicleData: {
        vehicleData: []
    },
    issuedTyreData: {
        issuedData: []
    },
    mountLoading: {
        isLoading: false
    }
}

const tyreSlice = createSlice({
    name: "jobCardTyre",
    initialState,
    reducers: {
        tyreInfoAvl: (state, { payload }) => {
            state.hasTyreInfo.hasInfo = payload;
        },
        tyreHasInfo: (state, { payload }) => {
            state.tyreInfo.tyrePosInfo = payload;
        },
        SELECT_WHEEL: (state, { payload }) => {
            state.selectedWheels.selectedId = payload;
        },
        selectedJobCardVehicleId: (state, { payload }) => {
            state.jobCardVehicleId.vehicleId = payload;
        },
        getSelectedWheelsForActions: (state, { payload }) => {
            state.selectedWheelsForActions.selectedWheelsData = payload;
        },
        getselectedCheckBoxState: (state, { payload }) => {
            state.selectedCheckBoxState.checkboxesState = payload;
        },
        getSelectedActivityRowData: (state, { payload }) => {
            state.selectedActivityRowData.activityRowData = payload;
        },
        getSelectedVehicleData: (state, { payload }) => {
            state.selectedVehicleData.vehicleData = payload;
        },
        getIssuedTyreData: (state, { payload }) => {
            state.issuedTyreData.issuedData = payload;
        },
        tyreMountLoading: (state, { payload }) => {
            state.mountLoading.isLoading = payload;
        },
    }
});

const { reducer, actions } = tyreSlice;

export const {
    tyreHasInfo, tyreInfoAvl, SELECT_WHEEL, selectedJobCardVehicleId, getSelectedWheelsForActions, getselectedCheckBoxState,
    getSelectedActivityRowData, getSelectedVehicleData, getIssuedTyreData, tyreMountLoading
} = actions;

export default reducer;